export type HydrostaticRowData = {
  phiRad: number;
  hydrostaticSum: number;
};

/**
 * Survey rows are the `[md, inclination, azimuth, tvd, dls]` tuples produced by
 * `calculateDeviationSurveyRowData`.
 */
export const SURVEY_MD = 0;

export const SURVEY_INCLINATION = 1;

export const SURVEY_AZIMUTH = 2;

export const SURVEY_TVD = 3;

export const SURVEY_DLS = 4;

export type SurveyPointAtMD = {
  measuredDepthFt: number;
  inclinationDeg: number;
  azimuthDeg: number;
  trueVerticalDepthFt: number;
  dogLegSeverityDeg100Ft: number;
};

export type MaxDogLegSeverity = {
  measuredDepthFt: number;
  dogLegSeverityDeg100Ft: number;
};
